import { appEvents } from "@cayo/shared/components/App/appEvents";
import { IPropertiesPanel } from "@cayo/shared/components/AppRoots/PropertiesPanelHolder/types";
import { bindingsUtils } from "@cayo/shared/scheme/bindings";
import { IActionHandlerParams } from "../types";

export const showProps = (actionId: string, parameters?: IActionHandlerParams) => {
  const actualId = parameters?.objects
    ? (bindingsUtils.resolveExpression(parameters.objects[0] as any, actionId) as string)
    : actionId;

  let parentId = parameters?.parentId;
  if (!parentId && parameters?.gridState?.selectedItems?.length) {
    parentId = parameters.gridState.selectedItems[0].objectPath;
  }

  if (!parentId && !parameters?.property) {
    parentId = parameters?.gridState?.id;
  }

  appEvents.trigger({
    showControl: {
      controlId: "scheme",
      parameters: {
        id: actualId || actionId,
        ...parameters, // TEMPORARY
        parentId,
      } as IPropertiesPanel,
    },
  });
};
